export const postsSelector = state => state.news.Post.newsData
export const loadingPostSelector = state => state.news.Post.isLoadingNews
export const totalNewsSelector = state => state.news.Post.totalNews
export const postSelector  = state => state.news.Post.newData
export const loadingPostDetailSelector = state => state.news.Post.isLoadingDetail